{
  "pages": {
    "teamSchedule": "Lịch làm việc",
    "assignments": "Gán lịch",
    "applyTemplate": "Gán mẫu lịch",
    "weeklyTemplates": "Mẫu lịch",
    "assignedTo": "Đang gán cho",
    "addWeeklyTemplate": "Thêm mẫu lịch",
    "editWeeklyTemplate": "Sửa mẫu lịch",
    "shiftTypes": "Loại ca",
    "timeOffTypes": "Loại phép",
    "timeOffList": "Nghỉ phép",
    "requestTimeOff": "Yêu cầu nghỉ phép",
    "timeOffDetails": "Chi tiết nghỉ phép",
    "leaveEntitlements": "Hạn mức phép",
    "leaveLedger": "Sổ phép",
    "leaveReport": "Báo cáo phép",
    "permissionDenied": "Bạn không có quyền xem lịch làm việc.",
    "permissionDeniedTeamSchedule": "Bạn không có quyền xem lịch team.",
    "permissionDeniedAssignments": "Bạn không có quyền xem gán lịch.",
    "permissionDeniedApply": "Bạn không có quyền gán mẫu lịch.",
    "permissionDeniedTemplates": "Bạn không có quyền xem mẫu lịch.",
    "permissionDeniedManageTemplates": "Bạn không có quyền quản lý mẫu lịch.",
    "permissionDeniedShiftTypes": "Bạn không có quyền xem loại ca.",
    "permissionDeniedTimeOffTypes": "Bạn không có quyền xem loại phép.",
    "permissionDeniedTimeOff": "Bạn không có quyền xem nghỉ phép.",
    "permissionDeniedRequest": "Bạn không có quyền yêu cầu nghỉ phép.",
    "permissionDeniedEntitlements": "Bạn không có quyền xem hạn mức phép.",
    "permissionDeniedLedger": "Bạn không có quyền xem sổ phép.",
    "permissionDeniedReport": "Bạn không có quyền xem báo cáo phép.",
    "tabs": {
      "requests": "Đơn nghỉ",
      "types": "Loại phép",
      "entitlements": "Hạn mức phép",
      "ledger": "Sổ phép",
      "report": "Báo cáo"
    },
    "tabsAria": "Phần nghỉ phép",
    "scheduleTabs": {
      "calendar": "Lịch làm việc",
      "shiftTypes": "Loại ca",
      "templates": "Mẫu lịch",
      "assignments": "Gán lịch"
    },
    "scheduleTabsAria": "Phần lịch team"
  },
  "days": {
    "monday": "Thứ hai",
    "tuesday": "Thứ ba",
    "wednesday": "Thứ tư",
    "thursday": "Thứ năm",
    "friday": "Thứ sáu",
    "saturday": "Thứ bảy",
    "sunday": "Chủ nhật",
    "sun": "CN",
    "mon": "T2",
    "tue": "T3",
    "wed": "T4",
    "thu": "T5",
    "fri": "T6",
    "sat": "T7"
  },
  "templateSource": {
    "clinic_template": "Theo phòng khám",
    "staff_fallback": "Chưa cấu hình lịch làm việc"
  },
  "timeOffStatus": {
    "pending": "Chờ duyệt",
    "approved": "Đã duyệt",
    "rejected": "Từ chối",
    "cancelled": "Đã hủy"
  },
  "dayStatus": {
    "working": "Làm việc",
    "off": "Nghỉ",
    "unconfigured": "Chưa cấu hình mẫu lịch",
    "pending": "Chưa đến ngày áp dụng",
    "pendingFrom": "Từ {{date}}",
    "lapsed": "Hết hiệu lực gán lịch",
    "lapsedResumeFrom": "Tiếp từ {{date}}",
    "time_off": "Nghỉ phép",
    "partial_time_off": "Nghỉ một phần ngày",
    "clinic_closed": "PK đóng cửa"
  },
  "hoursSource": {
    "shift": "Ca",
    "template": "Mẫu lịch",
    "staff_fallback": "Chưa cấu hình"
  },
  "entityStatus": {
    "active": "Đang dùng",
    "inactive": "Ngừng"
  },
  "quotaMode": {
    "yearly": "Theo năm",
    "perEvent": "Theo sự kiện",
    "none": "Không hạn mức"
  },
  "grantCadence": {
    "remainingYear": "Phần còn lại trong năm",
    "monthly": "Tích lũy từng tháng"
  },
  "grantAccrualFrom": {
    "confirmation": "Ngày chính thức",
    "joinDate": "Ngày vào làm"
  },
  "assignmentStatus": {
    "open": "Đang áp dụng",
    "closed": "Đã đóng",
    "all": "Tất cả trạng thái"
  },
  "departments": {
    "board": "Ban Giám đốc",
    "marketing": "Marketing",
    "reception": "Lễ tân",
    "assistant": "Phụ tá",
    "doctor": "Bác sĩ điều trị",
    "housekeeping": "Bếp, vệ sinh",
    "administrator": "Administrator",
    "accounting": "Kế toán"
  },
  "scheduleConfig": {
    "all": "Tất cả",
    "configured": "Đã cấu hình",
    "unconfigured": "Chưa cấu hình mẫu lịch"
  },
  "period": {
    "day": "Ngày",
    "week": "Tuần",
    "month": "Tháng",
    "ariaLabel": "Khoảng thời gian lịch",
    "prevMonth": "Tháng trước",
    "nextMonth": "Tháng sau",
    "prevWeek": "Tuần trước",
    "nextWeek": "Tuần sau",
    "prevDay": "Ngày trước",
    "nextDay": "Ngày sau"
  },
  "fields": {
    "status": "Trạng thái",
    "weeklyTemplate": "Mẫu lịch",
    "clinic": "Phòng khám",
    "department": "Phòng ban",
    "staff": "Nhân viên",
    "staffRequired": "Nhân viên *",
    "date": "Ngày",
    "dateRequired": "Ngày *",
    "startTime": "Giờ bắt đầu",
    "startTimeRequired": "Giờ bắt đầu *",
    "endTime": "Giờ kết thúc",
    "endTimeRequired": "Giờ kết thúc *",
    "workingTime": "Thời gian làm việc",
    "breakMode": "Nghỉ giữa ca",
    "breakModeNone": "Không nghỉ",
    "breakModeFixed": "Khung giờ cố định",
    "breakModeFlex": "Số phút linh hoạt",
    "breakTime": "Giờ nghỉ giữa ca",
    "breakStartTime": "Nghỉ từ",
    "breakEndTime": "Nghỉ đến",
    "breakMinutes": "Số phút nghỉ",
    "graceMinutesLate": "Cho phép đi trễ (phút)",
    "graceMinutesEarly": "Cho phép về sớm (phút)",
    "lateDeductMultiplier": "Hệ số trừ đi trễ",
    "lateDeductMultiplierHint": "1 phút trễ = hệ số × (đơn giá ngày / 480 phút). 0 = không trừ.",
    "notes": "Ghi chú",
    "reason": "Lý do",
    "reasonRequired": "Lý do *",
    "allDay": "Cả ngày",
    "halfDayLeave": "Nghỉ nửa ngày",
    "halfDaySetupTitle": "Thiết lập nghỉ nửa ngày",
    "halfDaySetupHint": "Chọn những ngày chỉ nghỉ một buổi.",
    "halfDay": "Nửa ngày",
    "morning": "Buổi sáng",
    "afternoon": "Buổi chiều",
    "halfDayWindow": "Ca nghỉ",
    "startDate": "Từ ngày",
    "startDateRequired": "Ngày bắt đầu *",
    "endDate": "Đến ngày",
    "endDateRequired": "Ngày kết thúc *",
    "periodRequired": "Thời gian *",
    "periodPlaceholder": "Chọn khoảng ngày",
    "dayLinesHint": "Chọn loại nghỉ cho từng ngày trong khoảng thời gian.",
    "halfDayExceptionsHint": "Mặc định mọi ngày trong khoảng nghỉ cả ngày. Chỉ thêm các ngày nghỉ nửa ngày.",
    "halfDayExceptionsEmpty": "Chưa có ngày nửa ngày.",
    "halfDayExceptionDatePlaceholder": "Chọn ngày",
    "dayLineDate": "Ngày",
    "dayLineMode": "Loại nghỉ",
    "dayModeFull": "Cả ngày",
    "dayModeWorking": "Làm việc",
    "type": "Loại",
    "typeRequired": "Loại phép *",
    "name": "Tên",
    "nameRequired": "Tên *",
    "shiftTypeName": "Tên loại ca",
    "code": "Mã",
    "codeRequired": "Mã *",
    "shiftTypeCode": "Mã ca",
    "codeHelper": "Viết HOA, chữ/số và gạch dưới (_). Ví dụ: OFFICE_HOURS. Nhập tên trước — hệ thống tự gợi ý mã; bạn có thể sửa lại.",
    "codePlaceholder": "Ví dụ: OFFICE_HOURS",
    "weeklyTemplateName": "Tên mẫu lịch",
    "weeklyTemplateCode": "Mã mẫu lịch",
    "timeOffTypeCodePlaceholder": "PHEP_NAM",
    "timeOffTypeNameRequired": "Tên loại phép *",
    "color": "Màu",
    "colorCustom": "Màu khác",
    "identitySection": "Thông tin chung",
    "hoursSection": "Giờ ca",
    "quotaModeSection": "Cách tính hạn mức",
    "paySection": "Chế độ chi trả",
    "payCompany": "Công ty chi trả",
    "payBhxh": "BHXH chi trả",
    "payUnpaid": "Không hưởng lương",
    "payCompanyHelper": "Công ty trả lương cho những ngày nghỉ được duyệt.",
    "payUnpaidHelper": "Công ty không trả lương. Không cấp hũ tự động.",
    "quotaCardYearly": "Hạn mức năm",
    "quotaCardPerEvent": "Giới hạn mỗi lần nghỉ",
    "quotaCardNone": "Không giới hạn",
    "quotaModeYearlyHint": "Có số dư phép và được cấp lại theo từng năm.",
    "quotaModePerEventHint": "Không có số dư năm; mỗi đơn có giới hạn riêng.",
    "quotaModeNoneHint": "Không theo dõi hoặc khấu trừ số dư phép.",
    "addDescription": "Thêm mô tả",
    "editDescription": "Sửa mô tả",
    "hideDescription": "Ẩn mô tả",
    "defaultAllocatedDaysPaidHelper": "Số ngày cấp cho nhân viên đủ điều kiện.",
    "autoGrantShortHelper": "Cấp hạn mức vào đầu mỗi kỳ phép.",
    "autoGrantRequiresCompanyPaid": "Chỉ dùng khi chế độ chi trả là công ty chi trả.",
    "tracksBalance": "Theo dõi số dư phép",
    "tracksBalanceQuota": "Theo dõi hạn mức phép",
    "quotaMode": "Cách tính hạn mức",
    "maxDaysPerRequest": "Số ngày tối đa / lần",
    "maxDaysPerRequestHelper": "Mỗi đơn nghỉ không được dài hơn số ngày này.",
    "isPaidLeave": "Nghỉ hưởng lương (tính công)",
    "isSocialInsurance": "Chế độ BHXH",
    "isSocialInsuranceHelper": "Công ty không trả lương ngày này. Nhân viên cần làm thủ tục hưởng bảo hiểm xã hội.",
    "autoGrant": "Tự động cấp phép hằng năm",
    "autoGrantOnHelper": "Cấp hũ phép năm cho nhân viên toàn thời gian đã chính thức. Năm cũ giữ nguyên, không chuyển số dư. Chọn cách cấp bên dưới.",
    "autoGrantOffHelper": "Tắt: HR cấp tay trên tab hạn mức. Nghỉ không lương (kể cả BHXH) không cấp hũ — mọi nhân viên đang làm đều xin được.",
    "grantCadence": "Cách cấp hạn mức",
    "grantCadenceRemainingYearHelper": "Một lần: số tháng đủ điều kiện còn lại trong năm × (ngày năm / 12). Ví dụ 3 tháng còn lại, 12 ngày/năm → 3 ngày.",
    "grantCadenceMonthlyHelper": "Tích lũy từng tháng đã qua trong năm. Job hàng ngày cộng dồn, không cắt số HR đã tăng.",
    "grantAccrualFrom": "Mốc tính phép",
    "grantAccrualFromConfirmationHelper": "Đếm tháng từ ngày chính thức (hết thử việc, hoặc ngày vào làm nếu không có thử việc). Ai được cấp vẫn là full-time đã chính thức.",
    "grantAccrualFromJoinDateHelper": "Đếm tháng từ ngày vào làm. Nếu thử việc xong giữa năm, phần tháng thử việc vẫn được tính vào hũ khi đã chính thức.",
    "year": "Năm",
    "yearRequired": "Năm *",
    "entitledDays": "Số ngày được cấp",
    "allocatedDays": "Số ngày phân bổ *",
    "defaultAllocatedDays": "Số ngày mặc định mỗi năm",
    "defaultAllocatedDaysHelper": "Nghỉ hưởng lương: số ngày cấp hũ cho full-time chính thức. Nghỉ không lương (kể cả BHXH): trần theo dõi, công ty không cấp hũ.",
    "overwriteExistingEntitlements": "Ghi đè hạn mức đã có",
    "usedDays": "Đã dùng",
    "remainingDays": "Còn lại",
    "effectiveFrom": "Hiệu lực từ",
    "effectiveTo": "Hiệu lực đến",
    "applyFrom": "Áp dụng từ ngày",
    "applyTo": "Áp dụng đến ngày",
    "dayStatus": "Trạng thái ngày",
    "rejectionReason": "Lý do từ chối",
    "rejectionReasonRequired": "Lý do từ chối *",
    "description": "Mô tả",
    "applicableClinics": "Phòng khám áp dụng",
    "shiftType": "Loại ca",
    "schedule": "Lịch",
    "from": "Từ *",
    "to": "Đến *",
    "createdBy": "Người tạo",
    "leaveApprovers": "Người duyệt phép",
    "leaveApproversEmpty": "Chưa gán",
    "leaveFollowers": "Người theo dõi đơn phép",
    "leaveFollowersEmpty": "Không bắt buộc",
    "leaveFollowersHelper": "Mặc định theo phòng ban và hồ sơ nhân viên. Có thể thêm hoặc xóa cho đơn này (tối đa {{max}}). Không gồm người duyệt phép.",
    "searchLeaveFollowers": "Tìm người theo dõi",
    "approvedBy": "Người duyệt",
    "rejectedBy": "Người từ chối",
    "clinicScope": "Phạm vi PK",
    "sourceTemplate": "Mẫu nguồn",
    "patternBrief": "Lịch tuần",
    "workingHours": "Giờ làm",
    "hours": "Giờ",
    "timeOffType": "Loại phép",
    "timeOffTypeRequired": "Loại phép *",
    "allocated": "Phân bổ",
    "working": "Làm việc",
    "shifts": "Ca",
    "start": "Bắt đầu",
    "end": "Kết thúc"
  },
  "filters": {
    "status": "Trạng thái",
    "weeklyTemplate": "Mẫu lịch",
    "clinic": "Phòng khám",
    "department": "Phòng ban",
    "designation": "Chức danh",
    "searchStaff": "Tìm nhân viên",
    "selectTimeOffType": "Chọn loại phép",
    "dateRangePlaceholder": "Chọn khoảng ngày",
    "search": "Tìm kiếm",
    "searchTimeOffPlaceholder": "Tìm mã đơn phép, nhân viên hoặc loại phép...",
    "searchTemplates": "Tìm mẫu lịch...",
    "searchShiftTypes": "Tìm loại ca...",
    "searchTimeOffTypesPlaceholder": "Tìm tên loại phép...",
    "searchEntitlementsPlaceholder": "Tìm nhân viên hoặc loại phép...",
    "searchLedgerPlaceholder": "Tìm nhân viên hoặc loại phép...",
    "searchReportPlaceholder": "Tìm nhân viên hoặc loại phép...",
    "staffId": "Lọc theo staff ID",
    "teamScheduleTitle": "Bộ lọc lịch team",
    "dayStatus": "Trạng thái lịch",
    "scheduleConfig": "Trạng thái mẫu lịch",
    "allTemplates": "Tất cả mẫu lịch",
    "allClinics": "Tất cả phòng khám",
    "allDepartments": "Tất cả phòng ban",
    "allDesignations": "Tất cả chức danh",
    "all": "Tất cả",
    "allTimeOffTypes": "Tất cả loại phép",
    "allLedgerKinds": "Tất cả loại bút toán",
    "timeOffDateRange": "Ngày nghỉ",
    "ledgerPostedRange": "Ngày ghi sổ",
    "selectClinic": "Chọn phòng khám",
    "selectStaffFilter": "Chọn nhân viên",
    "selectDayStatus": "Chọn trạng thái lịch",
    "allStaff": "Tất cả nhân viên",
    "allDayStatuses": "Tất cả trạng thái"
  },
  "actions": {
    "refresh": "Làm mới",
    "add": "Thêm",
    "edit": "Sửa",
    "delete": "Xóa",
    "save": "Lưu",
    "cancel": "Hủy",
    "close": "Đóng",
    "approve": "Duyệt",
    "approveRequest": "Duyệt đơn",
    "reject": "Từ chối",
    "rejectRequest": "Từ chối đơn",
    "editRequest": "Chỉnh sửa",
    "apply": "Áp dụng",
    "applying": "Đang áp dụng...",
    "create": "Tạo",
    "creating": "Đang tạo...",
    "cancellingShift": "Đang hủy ca...",
    "request": "Gửi yêu cầu",
    "view": "Xem",
    "addShift": "Thêm ca",
    "applyTemplate": "Áp dụng mẫu lịch",
    "assignTemplate": "Gán mẫu",
    "changeTemplate": "Đổi mẫu",
    "assignSchedule": "Gán lịch",
    "addWeeklyTemplate": "Thêm mẫu lịch",
    "addingWeeklyTemplate": "Đang thêm mẫu lịch...",
    "continueToAssign": "Tiếp tục",
    "skipAssign": "Bỏ qua",
    "addShiftType": "Thêm loại ca",
    "addTimeOffType": "Thêm loại phép",
    "requestTimeOff": "Yêu cầu nghỉ phép",
    "myTimeOffRequest": "Đơn nghỉ phép",
    "assignEntitlement": "Gán hạn mức",
    "grantDefaults": "Cấp theo mặc định",
    "viewLedger": "Sổ",
    "cancelShift": "Hủy ca",
    "cancelRequest": "Hủy yêu cầu",
    "moreActions": "Thêm thao tác",
    "history": "Lịch sử",
    "configureLeaveApprovers": "Cấu hình",
    "addHalfDayException": "Thêm ngày",
    "removeHalfDayException": "Xóa ngày nửa ngày"
  },
  "table": {
    "staff": "Nhân viên",
    "clinic": "Phòng khám",
    "department": "Phòng ban",
    "template": "Mẫu lịch",
    "status": "Trạng thái",
    "actions": "Thao tác",
    "name": "Tên",
    "shiftType": "Loại ca",
    "code": "Mã",
    "type": "Loại",
    "dates": "Thời gian",
    "reason": "Lý do",
    "timeOffCode": "Mã đơn phép",
    "year": "Năm",
    "entitled": "Được cấp",
    "used": "Đã dùng",
    "remaining": "Còn lại",
    "day": "Ngày",
    "hours": "Giờ",
    "schedule": "Lịch",
    "leaveApprovers": "Người duyệt",
    "leaveFollowers": "Người theo dõi",
    "workingHours": "Giờ làm",
    "tracksBalance": "Theo dõi số dư",
    "quotaMode": "Hạn mức",
    "maxDaysPerRequest": "Tối đa / lần",
    "isPaid": "Hưởng lương",
    "isSocialInsurance": "BHXH",
    "autoGrant": "Cấp tự động",
    "grantCadence": "Cách cấp",
    "grantAccrualFrom": "Mốc tính",
    "description": "Mô tả",
    "defaultAllocatedDays": "Mặc định",
    "timeOffType": "Loại phép",
    "timeOffPeriod": "Thời gian nghỉ",
    "payKind": "Chi trả",
    "days": "Số ngày",
    "daysPerYear": "{{days}} / năm",
    "daysPerRequest": "{{days}} / lần",
    "allocated": "Cấp phép",
    "ledgerPostedAt": "Ngày ghi",
    "ledgerKind": "Loại",
    "ledgerDays": "Số ngày",
    "ledgerSource": "Nguồn",
    "clinicScope": "Phạm vi PK",
    "sourceTemplate": "Mẫu lịch",
    "effectiveFrom": "Áp dụng từ",
    "effectiveTo": "Áp dụng đến",
    "patternBrief": "Lịch tuần",
    "breakFlex": "{{count}} phút",
    "createdAt": "Ngày tạo",
    "createdBy": "Người tạo",
    "updatedAt": "Ngày chỉnh sửa",
    "updatedBy": "Người cập nhật",
    "editedBy": "Người chỉnh sửa",
    "currentSchedule": "Lịch hiện tại",
    "notes": "Ghi chú",
    "designation": "Chức danh",
    "timeOffType": "Loại phép"
  },
  "dialogs": {
    "deleteConfirm": "Bạn có chắc muốn xóa?",
    "rejectTitle": "Từ chối yêu cầu nghỉ phép",
    "approveTitle": "Duyệt yêu cầu nghỉ phép?",
    "cancelTitle": "Hủy yêu cầu nghỉ phép?",
    "shiftTitle": "Ca làm việc",
    "shiftEditTitle": "Sửa ca",
    "shiftAddTitle": "Tạo ca",
    "editWeeklyTemplate": "Sửa mẫu lịch",
    "addWeeklyTemplate": "Thêm mẫu lịch",
    "wizardTemplate": "Mẫu lịch",
    "wizardAssign": "Gán mẫu",
    "assigningTemplate": "Gán mẫu {{name}}",
    "addDayShift": "Thêm ca — {{day}}",
    "editDayShift": "Sửa ca — {{day}}",
    "editShiftType": "Sửa loại ca",
    "addShiftType": "Thêm loại ca",
    "editTimeOffType": "Sửa loại phép",
    "viewTimeOffType": "Chi tiết loại phép",
    "viewTimeOff": "Chi tiết đơn nghỉ phép",
    "viewTimeOffWithCode": "Chi tiết đơn nghỉ phép {{code}}",
    "editTimeOff": "Sửa đơn nghỉ phép",
    "editTimeOffWithCode": "Sửa đơn nghỉ phép {{code}}",
    "addTimeOffType": "Thêm loại phép",
    "createTimeOffType": "Tạo loại phép",
    "createTimeOffTypeSubmit": "Tạo loại phép",
    "createShiftTypeSubmit": "Tạo loại ca",
    "creatingShiftType": "Đang tạo loại ca...",
    "requiredFieldsNote": "Các trường có dấu * là bắt buộc",
    "timeOffTypeActivityEmpty": "Chưa có hoạt động nào liên quan đến loại phép này.",
    "timeOffActivityEmpty": "Chưa có hoạt động nào liên quan đến đơn nghỉ phép này.",
    "assignEntitlement": "Gán hạn mức phép",
    "grantDefaults": "Cấp hạn mức theo loại phép",
    "grantDefaultsBody": "Cấp hũ năm cho nhân viên toàn thời gian đã chính thức, theo loại phép hưởng lương đang bật cấp tự động. Mốc tính (ngày chính thức / ngày vào làm) và cách cấp (một lần phần còn năm / tích lũy từng tháng) lấy từ cấu hình loại phép. Nghỉ không lương (kể cả BHXH) không cấp hũ. Không ghi đè số đã cấp trừ khi tick ghi đè. Năm cũ giữ nguyên.",
    "leaveLedger": "Sổ phép — {{staff}} · {{type}} · {{year}}",
    "leaveLedgerBody": "Hạn mức là cấp phép. Cộng trừ số dư chỉ qua sổ — không sửa dòng đã ghi.",
    "cancelShiftConfirm": "Hủy ca này?",
    "cancelShiftTitle": "Hủy ca làm việc?",
    "overwriteConfirm": "Ghi đè mẫu lịch hiện tại của nhân viên đã chọn?",
    "overwriteConfirmTitle": "Ghi đè lịch hiện tại?",
    "overwriteConfirmBody": "{{count}} nhân viên đã chọn đã có lịch trong khoảng ngày này. Tiếp tục sẽ ghi đè lịch của họ.",
    "approveBodyAllDay": "Yêu cầu sẽ được duyệt và chặn availability từ {{startDate}} đến {{endDate}}.",
    "approveBodyPartial": "Yêu cầu sẽ được duyệt và chặn availability ngày {{startDate}} từ {{startTime}} đến {{endTime}}.",
    "cancelBody": "Yêu cầu đang chờ sẽ bị hủy. Thao tác này không hoàn tác được."
  },
  "validation": {
    "required": "Trường này bắt buộc",
    "selectStaff": "Vui lòng chọn nhân viên",
    "selectClinic": "Vui lòng chọn phòng khám",
    "selectType": "Vui lòng chọn loại nghỉ",
    "selectDates": "Vui lòng chọn ngày",
    "reasonRequired": "Vui lòng nhập lý do",
    "invalidTimeRange": "Giờ kết thúc phải sau giờ bắt đầu",
    "fillRequired": "Vui lòng điền đủ thông tin bắt buộc",
    "codeNameRequired": "Vui lòng nhập mã và tên",
    "codeNameTemplateRequired": "Vui lòng nhập mã và tên mẫu lịch",
    "codeNameShiftTypeRequired": "Vui lòng nhập mã và tên loại ca",
    "shiftTypeNameMax": "Tên loại ca tối đa {{max}} ký tự",
    "shiftTypeCodeMax": "Mã loại ca tối đa {{max}} ký tự",
    "weeklyTemplateNameMax": "Tên mẫu lịch tối đa {{max}} ký tự",
    "weeklyTemplateCodeMax": "Mã mẫu lịch tối đa {{max}} ký tự",
    "weeklyTemplateDescriptionMax": "Mô tả tối đa {{max}} ký tự",
    "breakMinutesRequired": "Nhập số phút nghỉ giữa ca",
    "breakMinutesShorterThanShift": "Số phút nghỉ phải ngắn hơn giờ ca",
    "breakWindowRequired": "Chọn khung giờ nghỉ",
    "breakEndAfterStart": "Giờ nghỉ kết thúc phải sau giờ bắt đầu",
    "breakWindowWithinShift": "Khung giờ nghỉ phải nằm trong giờ ca",
    "codeNameTimeOffTypeRequired": "Vui lòng nhập mã và tên loại phép",
    "descriptionMax": "Mô tả tối đa 500 ký tự",
    "selectStaffAndType": "Chọn nhân viên và loại phép",
    "invalidYear": "Năm không hợp lệ",
    "allocatedDaysMin": "Số ngày phân bổ phải >= 0",
    "defaultAllocatedDaysRange": "Số ngày mặc định từ 0 đến 366",
    "maxDaysPerRequestRequired": "Nhập số ngày tối đa mỗi lần nghỉ",
    "maxDaysPerRequestRange": "Số ngày tối đa mỗi lần từ 1 đến 366",
    "requestExceedsEventMax": "Loại phép này tối đa {{max}} ngày mỗi lần",
    "selectWeeklyTemplate": "Chọn mẫu lịch",
    "selectAtLeastOneStaff": "Chọn ít nhất một nhân viên",
    "selectApplyDate": "Chọn ngày áp dụng",
    "templateNotForClinic": "Mẫu lịch không áp dụng cho phòng khám đang chọn",
    "loadingPleaseWait": "Đang tải dữ liệu, vui lòng đợi…",
    "selectStaffYup": "Chọn nhân viên",
    "selectTypeYup": "Chọn loại nghỉ",
    "leaveFollowersMax": "Tối đa {{max}} người theo dõi",
    "startDateRequired": "Ngày bắt đầu là bắt buộc",
    "endDateRequired": "Ngày kết thúc là bắt buộc",
    "endDateAfterStart": "Ngày kết thúc phải sau hoặc bằng ngày bắt đầu",
    "startTimeRequired": "Giờ bắt đầu là bắt buộc",
    "endTimeRequired": "Giờ kết thúc là bắt buộc",
    "endTimeAfterStart": "Giờ kết thúc phải sau giờ bắt đầu",
    "halfDayRequired": "Chọn buổi sáng hoặc buổi chiều",
    "dayLinesRequired": "Chọn ít nhất một ngày nghỉ",
    "halfDayExceptionsRequired": "Thêm ít nhất một ngày nghỉ nửa ngày",
    "halfDayWindowRequired": "Chọn ca nghỉ",
    "halfDayNoSchedule": "Ngày này không có lịch làm — không xin được nửa ngày",
    "reasonYupRequired": "Lý do là bắt buộc",
    "rejectionReasonRequired": "Cần nhập lý do từ chối",
    "selectClinicFirst": "Chọn phòng khám trước",
    "patternNeedWorkingDay": "Phải chọn ít nhất một ngày có ca làm việc",
    "patternOffHasShifts": "{{day}}: ngày nghỉ không được có ca",
    "patternNeedShift": "{{day}}: cần ít nhất một ca",
    "patternShiftTypeRequired": "{{day}}: ca {{index}} chưa chọn loại ca",
    "patternDuplicateShiftType": "{{day}}: trùng loại ca"
  },
  "misc": {
    "allDay": "Cả ngày",
    "allDaySuffix": "(Cả ngày)",
    "halfDay": "Nửa ngày",
    "totalLeaveDays": "Tổng ngày nghỉ: {{count}} ngày",
    "totalLeaveDaysShort": "Tổng ngày nghỉ",
    "offDay": "Ngày nghỉ",
    "off": "Nghỉ",
    "shift": "Ca",
    "noData": "Không có dữ liệu",
    "emptyAssignments": "Không có bản ghi gán lịch",
    "emptyTemplateAssignments": "Chưa gán mẫu này cho ai",
    "assignmentsNotFound": "Không tìm thấy bản ghi gán lịch",
    "emptyTimeOff": "Không có yêu cầu nghỉ phép",
    "noLeaveApprovers": "Chưa gán người duyệt — không nộp được đơn cho đến khi HR cấu hình trên hồ sơ nhân sự",
    "noTimeOffFound": "Không tìm thấy đơn nghỉ",
    "emptyTemplates": "Chưa có mẫu lịch",
    "emptyShiftTypes": "Chưa có loại ca",
    "emptyTimeOffTypes": "Chưa có loại phép",
    "noTimeOffTypesFound": "Không tìm thấy loại phép",
    "emptyEntitlements": "Chưa có hạn mức phép",
    "noEntitlementsFound": "Không tìm thấy hạn mức phép",
    "emptyLedger": "Chưa có bút toán",
    "noLedgerFound": "Không tìm thấy bút toán",
    "emptyReport": "Chưa có số dư phép",
    "noReportFound": "Không tìm thấy số dư phép",
    "addShiftRow": "Thêm ca trong ngày",
    "patternEditor": "Mẫu lịch",
    "patternEditorTitle": "Mẫu lịch theo loại ca",
    "notAvailable": "—",
    "allDaysOff": "Tất cả ngày nghỉ",
    "allClinics": "Tất cả phòng khám",
    "clinicCount": "{{count}} phòng khám",
    "unlimited": "Không thời hạn",
    "unlimitedBalance": "Không giới hạn",
    "ledgerKindAllocation": "Cấp phép",
    "ledgerKindConsumption": "Sử dụng",
    "ledgerSourceEntitlement": "Hạn mức",
    "ledgerSourceTimeOff": "Đơn nghỉ",
    "maxDaysPerRequest": "Tối đa {{count}} ngày / lần",
    "requestPayCompany": "Nghỉ hưởng lương",
    "requestPayUnpaid": "Nghỉ không lương",
    "requestPayBhxh": "BHXH chi trả",
    "requestTypeHint": "{{pay}}. Tối đa {{count}} ngày/lần nghỉ.",
    "requestTypeHintPayOnly": "{{pay}}.",
    "requestTypeHintUnlimited": "{{pay}}. Không giới hạn số dư.",
    "requestTypeRemaining": "(Còn {{count}} ngày)",
    "dayLinesSummary": "{{from}} đến {{to}} ({{count}} ngày phép)",
    "dateRange": "{{from}} đến {{to}}",
    "dateRangeAllDay": "{{from}} đến {{to}} (Cả ngày)",
    "leaveDayCount": "{{count}} ngày phép",
    "noStaff": "Không có nhân viên",
    "noWeeklyTemplate": "Chưa cấu hình mẫu lịch",
    "schedulePending": "Chưa đến ngày áp dụng",
    "schedulePendingFrom": "Áp dụng từ {{date}}",
    "scheduleLapsed": "Cần gán lại lịch",
    "partialTimeOff": "Nửa ngày",
    "unconfiguredHint": "Chưa cấu hình mẫu lịch — gán mẫu lịch hoặc click + để thêm ca",
    "pendingHint": "Lịch áp dụng từ {{date}}",
    "lapsedHint": "Ngoài khoảng gán lịch — cần gán lại hoặc thêm ca",
    "lapsedResumeHint": "Khoảng trống lịch — gán tiếp từ {{date}} hoặc thêm ca",
    "selectClinicToView": "Chọn phòng khám để xem lịch team.",
    "unconfiguredAlert": "{{count}} nhân viên cần gán / gán lại mẫu lịch.",
    "unconfiguredAlertReadonly": "Liên hệ quản lý để cấu hình lịch làm việc.",
    "noShiftTypeManual": "Không chọn (nhập giờ thủ công)",
    "noActiveShiftTypes": "Chưa có loại ca active. Tạo loại ca trước khi cấu hình mẫu lịch.",
    "shiftTypesList": "Loại ca: {{names}}",
    "deleteShiftAria": "Xóa ca",
    "workingAria": "{{day}} working",
    "templatesNotFound": "Không tìm thấy mẫu lịch",
    "shiftTypesNotFound": "Không tìm thấy loại ca",
    "yes": "Có",
    "no": "Không",
    "notFoundTimeOff": "Không tìm thấy yêu cầu nghỉ phép.",
    "timeOffNotFound": "Không tìm thấy yêu cầu nghỉ phép.",
    "balanceRemaining": "Còn {{remaining}} / {{allocated}} ngày ({{year}})",
    "balanceUnlimited": "Loại phép không giới hạn số dư",
    "noActiveTimeOffTypes": "Chưa có loại phép active. Tạo loại phép trước khi gửi yêu cầu.",
    "applyInfo": "Sao chép giờ làm từ mẫu lịch sang nhân viên đã chọn. Có hiệu lực từ ngày bắt đầu; để trống ngày kết thúc nếu áp dụng vô hạn. Sau ngày kết thúc nhân viên không còn lịch (trừ khi có assignment khác).",
    "applyFromHelper": "Từ ngày này lịch team / availability dùng pattern mới.",
    "applyToHelper": "Để trống = vô hạn. Sau ngày này nhân viên unconfigured trừ khi có assignment khác cover.",
    "applyingTemplate": "Đang gán: {{name}}",
    "loadingTemplates": "Đang tải mẫu lịch…",
    "selectTemplateRequired": "Chọn mẫu lịch *",
    "loadingStaff": "Đang tải nhân viên…",
    "loadingStaffList": "Đang tải danh sách nhân viên…",
    "selectStaff": "Chọn nhân viên",
    "selectStaffSection": "Chọn nhân viên",
    "selectAllFilteredStaff": "Chọn tất cả nhân viên trong danh sách đã lọc",
    "selectedStaffCount": "Đã chọn {{count}}/{{total}}",
    "noStaffMatchFilter": "Không có nhân viên khớp bộ lọc",
    "selectClinicFirst": "Chọn phòng khám trước",
    "selectClinicToFilterTemplates": "Chọn phòng khám trước để lọc mẫu lịch áp dụng được.",
    "selectClinicToFilterStaff": "Chọn phòng khám trước để lọc nhân viên thuộc PK đó.",
    "noTemplatesForClinic": "Không có mẫu lịch áp dụng cho phòng khám đã chọn.",
    "noStaffInClinic": "Không có nhân viên thuộc phòng khám đã chọn.",
    "staffPrimaryClinicHint": "Chỉ hiện nhân viên có primaryClinics gồm phòng khám đã chọn.",
    "overwriteIfExists": "Ghi đè nếu nhân viên đã có mẫu lịch",
    "templateNotForCurrentClinic": "Mẫu lịch đã chọn không áp dụng cho phòng khám hiện tại.",
    "startTime": "Giờ bắt đầu",
    "selectPrerequisites": "Chọn bác sĩ, phòng khám và ngày trước",
    "selectPrerequisitesHint": "Chọn bác sĩ, phòng khám và ngày để xem giờ trống",
    "loadingSlots": "Đang tải khung giờ trống...",
    "unavailable": "Không khả dụng",
    "noSlots": "Không có khung giờ",
    "noSlotsHint": "Không có khung giờ trống trong ngày này — thử ngày hoặc bác sĩ khác",
    "selectTime": "Chọn giờ",
    "rowsPerPage": "Số dòng mỗi trang:",
    "displayedRows": "{{from}}–{{to}} trong {{count}}",
    "displayedRowsMoreThan": "{{from}}–{{to}} trong hơn {{to}}",
    "reasonPrefix": "Lý do: {{reason}}"
  },
  "history": {
    "weeklyTemplateTitle": "Lịch sử mẫu lịch",
    "weeklyTemplateEmpty": "Chưa có lịch sử thay đổi cho mẫu này.",
    "assignmentTitle": "Lịch sử gán lịch",
    "assignmentEmpty": "Chưa có lịch sử thay đổi cho lần gán này.",
    "shiftTypeTitle": "Lịch sử loại ca",
    "shiftTypeEmpty": "Chưa có lịch sử thay đổi cho loại ca này.",
    "timeOffTitle": "Lịch sử đơn nghỉ",
    "timeOffEmpty": "Chưa có lịch sử thay đổi cho đơn này.",
    "timeOffTypeTitle": "Lịch sử loại phép",
    "timeOffTypeEmpty": "Chưa có lịch sử thay đổi cho loại phép này.",
    "entitlementTitle": "Lịch sử hạn mức phép",
    "entitlementEmpty": "Chưa có lịch sử thay đổi cho hạn mức này."
  },
  "toasts": {
    "loadFailed": "Không tải được dữ liệu",
    "loadFiltersFailed": "Không tải được bộ lọc",
    "loadTeamScheduleFailed": "Không tải được lịch team",
    "loadAssignmentsFailed": "Không tải được danh sách gán lịch",
    "loadApplyFailed": "Không tải được dữ liệu gán mẫu",
    "loadTemplatesFailed": "Không tải được danh sách mẫu lịch",
    "loadTemplateFailed": "Không tải được mẫu lịch",
    "loadShiftTypesFailed": "Không tải được danh sách loại ca",
    "loadTimeOffTypesFailed": "Không tải được danh sách loại phép",
    "loadTimeOffFailed": "Không tải được danh sách nghỉ phép",
    "loadTimeOffDetailsFailed": "Không tải được yêu cầu nghỉ phép",
    "loadEntitlementsFailed": "Không tải được hạn mức phép",
    "loadLedgerFailed": "Không tải được sổ phép",
    "loadReportFailed": "Không tải được báo cáo phép",
    "loadStaffFailed": "Không tải được danh sách nhân viên",
    "loadRequestOptionsFailed": "Không tải được dữ liệu yêu cầu nghỉ phép",
    "loadFormOptionsFailed": "Không tải được tùy chọn biểu mẫu",
    "loadShiftFailed": "Không tải được ca",
    "loadSlotsFailed": "Không tải được khung giờ trống",
    "saveSuccess": "Đã lưu thành công",
    "saveFailed": "Lưu thất bại",
    "deleteSuccess": "Đã xóa",
    "deleteFailed": "Xóa thất bại",
    "approveSuccess": "Đã duyệt nghỉ phép",
    "approveFailed": "Không duyệt được yêu cầu",
    "rejectSuccess": "Đã từ chối nghỉ phép",
    "rejectFailed": "Không từ chối được yêu cầu",
    "cancelSuccess": "Đã hủy yêu cầu nghỉ phép",
    "cancelFailed": "Không hủy được yêu cầu",
    "requestSuccess": "Đã gửi yêu cầu nghỉ phép",
    "requestUpdated": "Đã cập nhật đơn nghỉ phép",
    "requestUpdateFailed": "Không cập nhật được đơn nghỉ phép",
    "requestFailed": "Không gửi được yêu cầu nghỉ phép",
    "leaveApproverRequired": "Nhân sự này chưa có người duyệt phép trên hồ sơ hoặc phòng ban.",
    "leaveApproverRequiredReadonly": "Nhân sự này chưa có người duyệt phép trên hồ sơ hoặc phòng ban. Liên hệ quản trị viên để gán rồi thử lại.",
    "halfDayNoSchedule": "Ngày này không có lịch làm — không xin được nửa ngày.",
    "halfDayInvalidWindow": "Khung giờ nghỉ không khớp lịch làm việc.",
    "applySuccess": "Đã áp dụng mẫu lịch",
    "applyFailed": "Áp dụng mẫu lịch thất bại",
    "applyTimeout": "Áp dụng mẫu lịch quá lâu — thử lại với ít nhân viên hơn hoặc bật ghi đè từng đợt",
    "applySuccessCount": "Đã áp dụng cho {{count}} nhân viên",
    "applySkippedCount": "Bỏ qua {{count}} nhân viên (đã có mẫu lịch)",
    "shiftSaved": "Đã lưu ca",
    "shiftCreated": "Đã tạo ca",
    "shiftUpdated": "Đã cập nhật ca",
    "shiftDeleted": "Đã xóa ca",
    "shiftCancelled": "Đã hủy ca",
    "shiftCancelFailed": "Hủy ca thất bại",
    "shiftSaveFailed": "Lưu ca thất bại",
    "templateCreated": "Đã tạo mẫu lịch",
    "templateUpdated": "Đã cập nhật mẫu lịch",
    "templateSaveFailed": "Lưu mẫu lịch thất bại",
    "shiftTypeCreated": "Đã tạo loại ca",
    "shiftTypeUpdated": "Đã cập nhật loại ca",
    "shiftTypeSaveFailed": "Lưu loại ca thất bại",
    "timeOffTypeCreated": "Đã tạo loại phép",
    "timeOffTypeUpdated": "Đã cập nhật loại phép",
    "timeOffTypeSaveFailed": "Lưu loại phép thất bại",
    "entitlementSaved": "Đã lưu hạn mức phép",
    "entitlementSaveFailed": "Lưu hạn mức thất bại",
    "grantDefaultsSuccess": "Đã cấp hạn mức: tạo {{created}}, cập nhật {{updated}}, bỏ qua {{skipped}}",
    "grantDefaultsFailed": "Cấp hạn mức mặc định thất bại",
    "statusUpdated": "Đã cập nhật trạng thái",
    "statusUpdateFailed": "Cập nhật trạng thái thất bại",
    "selectClinicFirst": "Chọn phòng khám trước"
  },
  "placeholders": {
    "selectStaff": "Chọn nhân viên",
    "selectClinic": "Chọn phòng khám",
    "shiftNotes": "Nhập ghi chú",
    "shiftTypeName": "Ví dụ: Ca hành chính",
    "startTime": "Giờ bắt đầu",
    "endTime": "Giờ kết thúc",
    "breakMode": "Chọn chế độ nghỉ",
    "breakStartTime": "Nghỉ từ",
    "breakEndTime": "Nghỉ đến",
    "breakMinutes": "Ví dụ: 60",
    "graceMinutesLate": "Ví dụ: 15",
    "graceMinutesEarly": "Ví dụ: 15",
    "lateDeductMultiplier": "Ví dụ: 1",
    "applicableClinics": "Tất cả phòng khám",
    "weeklyTemplateName": "Nhập tên mẫu lịch",
    "weeklyTemplateCode": "Nhập mã mẫu lịch",
    "weeklyTemplateDescription": "Nhập mô tả"
  },
  "busyTime": {
    "title": "Thời gian bận",
    "dateLabel": "Ngày {{date}}",
    "line": "Bận {{start}}–{{end}} · {{reason}}",
    "outsideShift": "Ngoài ca",
    "empty": "Chưa có thời gian bận trong ngày này.",
    "conflictsTitle": "Các lịch hẹn sau vẫn giữ nguyên. Hãy chuyển chúng nếu cần.",
    "noStaffProfile": "Tài khoản chưa gắn hồ sơ nhân sự nên không tạo được thời gian bận.",
    "selectClinic": "Chọn phòng khám trước khi đặt thời gian bận.",
    "deleteTitle": "Xóa thời gian bận",
    "deleteConfirm": "Xóa khoảng bận {{start}}–{{end}}?",
    "reasons": {
      "meeting": "Họp",
      "lunch": "Ăn trưa",
      "away": "Ra ngoài",
      "training": "Đào tạo",
      "other": "Khác"
    },
    "errors": {
      "BUSY_OUTSIDE_SHIFT": "Khoảng bận phải nằm trọn trong ca làm việc.",
      "BUSY_OVERLAP": "Khoảng này chồng với một thời gian bận khác.",
      "BUSY_FORBIDDEN": "Bạn chỉ sửa được thời gian bận của chính mình.",
      "staff_busy": "Bác sĩ đang bận trong khung giờ này."
    },
    "fields": {
      "staff": "Nhân sự",
      "time": "Thời gian bận",
      "reason": "Lý do",
      "notes": "Ghi chú"
    },
    "placeholders": {
      "staff": "Chọn nhân sự",
      "reason": "Chọn lý do",
      "notes": "Ví dụ: Họp giao ban"
    }
  }
}
